import { render } from "./HistoryToday.vue?vue&type=template&id=895305fa&scoped=true"
import script from "./HistoryToday.vue?vue&type=script&lang=js"
export * from "./HistoryToday.vue?vue&type=script&lang=js"

import "./HistoryToday.vue?vue&type=style&index=0&id=895305fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-895305fa"]])

export default __exports__